<template>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-select"></require>

  <div class="form-row">
    <div class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-input type="text" label="Country" placeholder="Type to search" value.bind="model.text & debounce" maxlength="100"></bs-form-input>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-select label="Approval" placeholder="Any approval" value.bind="model.approvalRequirement" options.bind="enumService.approvalRequirements" value-path="value" name-path="name"></bs-form-select>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-select label="Approval Category" placeholder="Any approval category" value.bind="model.approveType" options.bind="enumService.approvalTypes" value-path="value" name-path="name"></bs-form-select>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-select label="Approval Level" placeholder="Any approval level" value.bind="model.approvalLevelId" options.bind="keywordsService.approvalLevels" value-path="id" name-path="name"></bs-form-select>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-select label="Archive" value.bind="model.includeArchived" options.bind="archiveOptions" value-path="value" name-path="name"></bs-form-select>
    </div>
  </div>
</template>
